
import React from 'react';
import { Shield, Lock } from 'lucide-react';

const SecuritySection: React.FC = () => {
  return (
    <div className="mt-20 bg-gradient-to-r from-yellow-300 via-beige to-yellow-300 rounded-3xl shadow-md border border-yellow-500 p-8 md:p-12 max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="space-y-6 flex-1">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-1.5 rounded-full">
            <Shield className="w-4 h-4 text-darkgray" />
            <span className="text-sm font-montserrat font-bold text-darkgray">Säkerhet</span>
          </div>
          
          <h3 className="text-3xl md:text-4xl font-montserrat font-bold text-darkgray">Säker hantering av känslig upphandlingsdata</h3>
          
          <p className="text-lg text-darkgray/80 font-opensans">
            Vi förstår att upphandlingsdata är känslig. Därför skyddar vi all information med avancerad kryptering, 
            fullständig GDPR-efterlevnad och strikta åtkomstbegränsningar.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="bg-white/80 p-4 rounded-lg flex items-start gap-3">
              <Lock className="h-5 w-5 text-yellow-500 flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-montserrat font-bold text-darkgray">Säker datalagring</h4>
                <p className="text-sm text-darkgray/70 font-opensans">All känslig anbudsdata lagras krypterad och på servrar inom EU</p>
              </div>
            </div>
            <div className="bg-white/80 p-4 rounded-lg flex items-start gap-3">
              <Shield className="h-5 w-5 text-yellow-500 flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-montserrat font-bold text-darkgray">Åtkomstbegränsningar</h4>
                <p className="text-sm text-darkgray/70 font-opensans">Detaljerad kontroll över vilka i ditt team som kan se specifik upphandlingsdata</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex-shrink-0 w-full md:w-auto max-w-xs">
          <img 
            src="/lovable-uploads/c8dc19f2-244b-473b-9c64-a53d09044778.png" 
            alt="EU GDPR Compliant" 
            className="w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default SecuritySection;
